import { CallTourScriptItem } from "./vibrato-api"

const aiVoiceId = "bIHbv24MWmeRgasZH58o"
const aiCallerVoiceId = "cjVigY5qzO86Huf0OWal"
const humanVoiceId = "SAz9YHcvj6GT2YYXdXww"

// Introductory script that prompts scenario selection
const introScript: (CallTourScriptItem & { speaker: string; delay?: number | null })[] = [
  {
    speaker: "ai",
    display_text:
      "Hi! I'm your A.I. assistant from Vibrato. I make phone calls for you—saving you time, money, and stress.",
    text: "Hi! I'm your A.I. assistant from Vibrato. I make phone calls for you—saving you time, money, and stress.",
    voice_id: aiVoiceId
  },
  {
    speaker: "ai",
    display_text: "I can handle any call you dread making. Choose a scenario below to see me in action:",
    text: "I can handle any call you dread making. Choose a scenario below to see me in action:",
    voice_id: aiVoiceId
  }
]

// Healthcare Appointment Scheduling - Targets phone anxiety and scheduling stress
const healthcareScript: (CallTourScriptItem & {
  speaker: string
  delay?: number | null
})[] = [
  {
    speaker: "you",
    display_text: "Let's book a dental cleaning, without the hold music. Our A.I. will take it from here.",
    text: "Let's book a dental cleaning, without the hold music. Our A.I. will take it from here.",
    voice_id: aiVoiceId
  },
  {
    speaker: "human",
    display_text: "Thank you for calling Bright Smile Dental, this is Jessica. How can I help you?",
    text: "Thank you for calling Bright Smile Dental, this is Jessica. How can I help you?",
    voice_id: humanVoiceId,
    delay: 1000
  },
  {
    speaker: "ai",
    display_text: "Hi Jessica, I'd like to schedule a routine cleaning for Sarah Johnson. She's an existing patient.",
    text: "Hi Jessica, I'd like to schedule a routine cleaning for Sarah Johnson. She's an existing patient.",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text: "Of course. I have availability next Tuesday at 2 PM or Thursday at 10 AM. Which is better?",
    text: "Of course. I have availability next Tuesday at two P M or Thursday at ten A M. Which is better?",
    voice_id: humanVoiceId,
    delay: 500
  },
  {
    speaker: "ai",
    display_text: "Thursday at 10 AM is perfect.",
    text: "Thursday at ten A M is perfect.",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text: "Great, she's all set for Thursday at 10. We'll send a reminder text the day before.",
    text: "Great, she's all set for Thursday at ten. We'll send a reminder text the day before.",
    voice_id: humanVoiceId
  },
  {
    speaker: "you",
    display_text:
      "And just like that, you're booked. No hold music, no phone tag. You just saved 15 minutes thanks to our A.I. What's next?",
    text: "And just like that, you're booked. No hold music, no phone tag. You just saved fifteen minutes thanks to our A.I. <break time=\"1s\" /> What's next?",
    voice_id: aiVoiceId,
    delay: 1500
  }
]

// Subscription Cancellation - Targets frustration with retention tactics
const subscriptionScript: (CallTourScriptItem & {
  speaker: string
  delay?: number | null
})[] = [
  {
    speaker: "you",
    display_text:
      "Time to cancel that gym membership. Our AI will handle the conversation, so you can skip the sales pitch.",
    text: "Time to cancel that gym membership. Our A.I. will handle the conversation, so you can skip the sales pitch.",
    voice_id: aiVoiceId
  },
  {
    speaker: "human",
    display_text:
      "FitZone customer service. Before we proceed, can I interest you in our new premium package at 50% off?",
    text: "FitZone customer service. Before we proceed, can I interest you in our new premium package at fifty percent off?",
    voice_id: humanVoiceId,
    delay: 1000
  },
  {
    speaker: "ai",
    display_text: "Hi, I'm calling to cancel the membership for Jennifer Smith, member ID 4789. Please don't upsell.",
    text: "Hi, I'm calling to cancel the membership for Jennifer Smith, member ID four seven eight nine. Please don't upsell.",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text: "I understand. What if we freeze the account for 6 months instead? No charge.",
    text: "I understand. What if we freeze the account for six months instead? No charge.",
    voice_id: humanVoiceId,
    delay: 500
  },
  {
    speaker: "ai",
    display_text: "No thank you, please proceed with the cancellation. What is the final billing date?",
    text: "No thank you, please proceed with the cancellation. What is the final billing date?",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text: "Okay, the cancellation is processed. Her final bill is October 15th.",
    text: "Okay, the cancellation is processed. Her final bill is October fifteenth.",
    voice_id: humanVoiceId
  },
  {
    speaker: "you",
    display_text:
      "Done. Our A.I. handled the cancellation so you didn't have to. You're saving $588 a year, effective immediately.",
    text: "Done. Our A.I. handled the cancellation so you didn't have to. You're saving five hundred eighty-eight dollars a year, effective immediately.",
    voice_id: aiVoiceId,
    delay: 1500
  }
]

// Bill Negotiation - Targets money-saving motivation
const billNegotiationScript: (CallTourScriptItem & {
  speaker: string
  delay?: number | null
})[] = [
  {
    speaker: "you",
    display_text: "Cable bill too high? Our A.I. will negotiate a better rate so you can get back to your show.",
    text: "Cable bill too high? Our A.I. will negotiate a better rate so you can get back to your show.",
    voice_id: aiVoiceId
  },
  {
    speaker: "human",
    display_text: "Thank you for calling Megacom Cable, this is Rachel. How can I help?",
    text: "Thank you for calling Megacom Cable, this is Rachel. How can I help?",
    voice_id: humanVoiceId,
    delay: 1000
  },
  {
    speaker: "ai",
    display_text:
      "Hi Rachel, I'm calling for Michael Chen, account 5521-8847. His bill went up, and he's considering switching to a competitor who's offering $35 less. Can you match that?",
    text: "Hi Rachel, I'm calling for Michael Chen, account five five two one, eight eight four seven. His bill went up, and he's considering switching to a competitor who's offering thirty-five dollars less. Can you match that?",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text: "Let me check... I can offer a $25 monthly discount for the next year. That's our best promotion.",
    text: "Let me check... I can offer a twenty-five dollar monthly discount for the next year. That's our best promotion.",
    voice_id: humanVoiceId,
    delay: 500
  },
  {
    speaker: "ai",
    display_text:
      "He's been a loyal customer for 4 years. Can you add a loyalty credit to get closer to the $35 discount?",
    text: "He's been a loyal customer for four years. Can you add a loyalty credit to get closer to the thirty-five dollar discount?",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text:
      "Okay, with a loyalty credit, I can do $32 off per month for 12 months. That's the absolute best I can offer.",
    text: "Okay, with a loyalty credit, I can do thirty-two dollars off per month for twelve months. That's the absolute best I can offer.",
    voice_id: humanVoiceId
  },
  {
    speaker: "you",
    display_text:
      "Negotiation complete. Our A.I. just saved you $384 for the year without the awkward haggling. Enjoy the savings.",
    text: "Negotiation complete. Our A.I. just saved you three hundred eighty-four dollars for the year without the awkward haggling. Enjoy the savings.",
    voice_id: aiVoiceId,
    delay: 1500
  }
]

// Emergency Service Call - Targets time-critical situations
const emergencyScript: (CallTourScriptItem & {
  speaker: string
  delay?: number | null
})[] = [
  {
    speaker: "you",
    display_text: "Leaky pipe? Our A.I. will call a plumber so you can focus on the fix, not the phone call.",
    text: "Leaky pipe? Our A.I. will call a plumber so you can focus on the fix, not the phone call.",
    voice_id: aiVoiceId
  },
  {
    speaker: "human",
    display_text: "City Plumbing emergency line. What's your emergency?",
    text: "City Plumbing emergency line. What's your emergency?",
    voice_id: humanVoiceId,
    delay: 1000
  },
  {
    speaker: "ai",
    display_text:
      "Hi, I have a water heater leaking at 1247 Oak Street. The homeowner needs same-day service immediately.",
    text: "Hi, I have a water heater leaking at one two four seven Oak Street. The homeowner needs same-day service immediately.",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text: "Understood. I can have a technician there by 2 PM today. The service call is $150.",
    text: "Understood. I can have a technician there by two P M today. The service call is one hundred and fifty dollars.",
    voice_id: humanVoiceId,
    delay: 500
  },
  {
    speaker: "ai",
    display_text: "Perfect, book it. Please have the technician text 555-0123 thirty minutes before arrival.",
    text: "Perfect, book it. Please have the technician text five five five, zero one two three thirty minutes before arrival.",
    voice_id: aiCallerVoiceId
  },
  {
    speaker: "human",
    display_text: "Confirmed. Service ticket #WH-4432 is booked for 2 PM.",
    text: "Confirmed. Service ticket number W H dash four four three two is booked for two P M.",
    voice_id: humanVoiceId
  },
  {
    speaker: "you",
    display_text:
      "Help is on the way. Our A.I. handled the call in 30 seconds so you could deal with the leak. Problem solved.",
    text: "Help is on the way. Our A.I. handled the call in thirty seconds so you could deal with the leak. Problem solved.",
    voice_id: aiVoiceId,
    delay: 1500
  }
]

// Export all scripts for use in tour selection
export { introScript, healthcareScript, subscriptionScript, billNegotiationScript, emergencyScript }
